import {
  Transaction,
  TransactionDirectionEnum,
  TransactionDto,
  TransactionListFilters,
  TransactionListFiltersDto,
  TransactionTypeDtoEnum,
} from '~models/Transaction';
import { isNotEmptyValue } from '@scansource-brazil/zeus-core-ui/data';

export class TransactionAdapter {
  static toView(data: TransactionDto): Transaction {
    const transaction = new Transaction({});

    transaction._id = String(data.id);
    transaction.transactionDateTime = new Date(data.transactionDateTime);
    transaction.amount = convertToBrCurrency(data.value);
    transaction.type = TransactionTypeDtoEnum[
      data.type
    ] as unknown as Transaction['type'];
    transaction.transactionDirection = TransactionDirectionEnum[
      data.transactionDirection
    ] as unknown as Transaction['transactionDirection'];
    transaction.sign = data.sign;
    transaction.source = data.source;
    transaction.description = data.description;
    transaction.transactionIdentifier = data.transactionIdentifier;
    transaction.username = data.username;

    return new Transaction(transaction);
  }
}

export class TransactionListFilterAdapter {
  static toDto(data: TransactionListFilters): TransactionListFiltersDto {
    const _filter = new TransactionListFiltersDto();
    if (!data.date?.length) {
      _filter.StartDate = formatToISODate(
        new Date(new Date().setDate(new Date().getDate() - 5)),
      );
      _filter.EndDate = formatToISODate(new Date(Date.now()));
    } else if (data.date.at(0)) {
      _filter.StartDate = formatToISODate(data.date.at(0));
      _filter.EndDate = !data.date.at(1)
        ? formatToISODate(data.date.at(0))
        : formatToISODate(data.date.at(1));
    }

    if (isNotEmptyValue(data.transactionDirection))
      _filter.Type = TransactionDirectionEnum[data.transactionDirection] as any;

    if (data.description) _filter.Description = data.description;

    if (data.source) _filter.Source = data.source;

    if (data.transactionIdentifier)
      _filter.TransactionIdentifier = data.transactionIdentifier;

    if (data.page) _filter.Page = data.page;

    if (data.pageSize) _filter.PageSize = data.pageSize;

    return _filter;
  }
}
